import { render } from "./refusedReservations.vue?vue&type=template&id=99bcd294"
import script from "./refusedReservations.vue?vue&type=script&lang=js"
export * from "./refusedReservations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__